/**
 * @generated SignedSource<<432403b5b0217b21cfc71aa7b056c028>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeliveryOrderWindowPaginator_query$data = {
  readonly deliveryOrders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      };
    }>;
    readonly pages: {
      readonly " $fragmentSpreads": FragmentRefs<"Pagination_pages">;
    };
    readonly totalCount: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"DeliveryOrderConnectionDataTable_deliveryOrderConnection">;
  };
  readonly " $fragmentType": "DeliveryOrderWindowPaginator_query";
};
export type DeliveryOrderWindowPaginator_query$key = {
  readonly " $data"?: DeliveryOrderWindowPaginator_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeliveryOrderWindowPaginator_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filters"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "order"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "page"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageSize"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./DeliveryOrderWindowPaginatorRefreshQuery.graphql')
    }
  },
  "name": "DeliveryOrderWindowPaginator_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters"
        },
        {
          "kind": "Variable",
          "name": "order",
          "variableName": "order"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "pageSize",
          "variableName": "pageSize"
        }
      ],
      "concreteType": "DeliveryOrderConnection",
      "kind": "LinkedField",
      "name": "deliveryOrders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Pages",
          "kind": "LinkedField",
          "name": "pages",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Pagination_pages"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DeliveryOrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DeliveryOrder",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DeliveryOrderConnectionDataTable_deliveryOrderConnection"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "a022bc64d45695031506c2617f4a829f";

export default node;
